import React from 'react';
import Background from "./components/Background"
import Container from './components/Container'
import { send } from 'emailjs-com';

import './assets/style/basic.css'
import './assets/style/layout.css'
import './assets/style/newSkin.css'
import './assets/style/ionicons.css'
import './assets/style/font-awesome-css.min.css'


function App() {

    return (
        <div className="container-fluid">
            <Background />
            <Container />
        </div>
    );
};

export default App;
